import { render, staticRenderFns } from "./slideComment.vue?vue&type=template&id=48808508&scoped=true"
import script from "./slideComment.vue?vue&type=script&lang=js"
export * from "./slideComment.vue?vue&type=script&lang=js"
import style0 from "./slideComment.vue?vue&type=style&index=0&id=48808508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48808508",
  null
  
)

export default component.exports